import React, {FC, useState} from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Image, InputDialog, SectionNotification, Text, TextButton} from 'wix-ui-tpa/cssVars'

import cardImageSrc from '../../../../assets/images/card.png'

import {cardGuaranteeNoticeDataHooks} from './constants'
import {classes} from './styles.st.css'

interface CardGuaranteeNoticeProps {
  guestPolicy?: string | null
}

export const CardGuaranteeNotice: FC<CardGuaranteeNoticeProps> = ({guestPolicy}) => {
  const {t} = useTranslation()
  const [isPolicyOpen, setIsPolicyOpen] = useState(false)
  const hasGuestPolicy = Boolean(guestPolicy)
  const paymentPolicyTitle = t('uou-reservations.reservation-details.card-guarantee.payment-policy')
  const closeDialog = () => setIsPolicyOpen(false)

  return (
    <>
      <div data-hook={cardGuaranteeNoticeDataHooks.root()}>
        <SectionNotification type="alert" className={classes.notice}>
          <SectionNotification.Text>
            <div className={classes.body}>
              <div className={classes.titleRow}>
                <Image className={classes.icon} src={cardImageSrc} alt="" width={24} height={24} />
                <Text className={classes.title} tagName="p">
                  {t('uou-reservations.reservation-details.card-guarantee.title')}
                </Text>
              </div>
              <Text className={classes.description} tagName="p">
                {t('uou-reservations.reservation-details.card-guarantee.description')}
              </Text>
              {hasGuestPolicy ? (
                <TextButton
                  className={classes.link}
                  onClick={() => setIsPolicyOpen(true)}
                  data-hook={cardGuaranteeNoticeDataHooks.paymentPolicyLink()}
                >
                  {paymentPolicyTitle}
                </TextButton>
              ) : null}
            </div>
          </SectionNotification.Text>
        </SectionNotification>
      </div>
      {hasGuestPolicy ? (
        <InputDialog
          isOpen={isPolicyOpen}
          onClose={closeDialog}
          title={paymentPolicyTitle}
          closeButtonAriaLabel={t('uou-reservations.shared.modal-close-button')}
          primaryButton={{
            text: t('uou-reservations.reservation-details.terms-privacy.close'),
            onClick: closeDialog,
          }}
          forceBWTheme
          className={classes.policyDialog}
        >
          <Text tagName="p" className={classes.dialogContent}>
            {guestPolicy}
          </Text>
        </InputDialog>
      ) : null}
    </>
  )
}
